export default __webpack_public_path__ + "static/media/hacksaw-gaming.cf9a4a73.png";